import React, { FC } from 'react';
import ModalDialog from '../../components/modal/ModalDialog';
import { useTranslation } from 'react-i18next';
import { SpocRequiredFor } from './CheckRequiredSpoc';

type Props = {
    spocName: string;
    onAcceptSpocChange: () => void;
    onRejectSpocChange: () => void;
    componentName: SpocRequiredFor;
};

export const SpocChangeDialog: FC<Props> = ({ spocName, onAcceptSpocChange, onRejectSpocChange, componentName }) => {
    const { t } = useTranslation();

    let message: string;
    switch (componentName) {
        case SpocRequiredFor.ORDER:
            message = t('components.collectionSwitchModal.message.order');
            break;
        case SpocRequiredFor.ORDERLIST:
            message = t('components.collectionSwitchModal.message.orderlist');
            break;
        case SpocRequiredFor.LOCAL_CONTENT_PRODUCT:
            message = t('components.collectionSwitchModal.message.localContentProduct');
            break;
    }

    return (
        <ModalDialog
            show={true}
            title="Context change required"
            preventClosingAction={true}
            isHeadlineHidden={true}
            onCloseButtonClick={onRejectSpocChange}
            overwriteWidth={true}
            width={590}
        >
            <p>
                {message}
                <br />
                <br />
                <b>{spocName}</b>
            </p>

            <div className="dlb-actions" style={{ marginTop: '30px' }}>
                <a className="lk lk-primary fl-right" style={{ marginBottom: '20px' }} onClick={onAcceptSpocChange}>
                    {t('switch')}
                </a>
                <a className="lk fl-right" onClick={onRejectSpocChange}>
                    {t('cancel')}
                </a>
            </div>
        </ModalDialog>
    );
};
